<template>
 <div class="s_user_cash_out_export_pop">
    <el-dialog :title="'导出用户资金流水'" class="s-user-cash-out-dialog" top="15vh" width="800px" :close-on-click-modal="false" :visible.sync="show">
      <el-form :model="formData" label-width="140px" size="mini">
        <el-row>
          <el-col :span="12">
              <el-form-item label="导出资金类别：">
                <el-select v-model="formData.category" placeholder="请选择">
                  <el-option v-for="item in options"  :key="item.value" :label="item.title" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
              <el-form-item label="导出资金类型：">
                <el-select v-model="formData.type" placeholder="请选择">
                  <el-option v-for="item in optionsSecond"  :key="item.value" :label="item.title" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
              <el-form-item label="导出日期范围：">
                <el-date-picker v-model="formData.date_time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
              <el-form-item label="导出用户id：">
                <el-input v-model="formData.user_id" placeholder="请输入导出用户id"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false" >取 消</el-button>
        <el-button type="primary" @click="apiExportCashHandel">确定导出</el-button>
      </div>
    </el-dialog>  
 </div>
</template>

<script>
import { apiExportUserMoney } from '@/utils/api.js'
export default {
  data() {
    return {
      show: false,
      value1: [],
      formData: {
        category: 'ALL',
        type: 'ALL',
        date_time: []
      },
      options: [
        { title: '全部', value: 'ALL' },
        { title: '本金结算', value: 1 },
        { title: '佣金结算', value: 2 },
      ],
      optionsSecond: [
        { title: '全部', value: 'ALL' },
        { title: '订单', value: 4 },
        { title: '提现', value: 2 },
        { title: '推广', value: 5 },
      ],
    }
  },
  methods: {
    onShow() {
      console.log(this.formData)
      this.show = true
    },
    onClose() {
      this.show = false
    },
    // 确认导出
    async apiExportCashHandel() {
      let loading = this.$loading()
      const { success, data } = await apiExportUserMoney(this.formData).catch(() => loading.close())
      loading.close()
      if(!success) return
      let a = document.createElement('a')
      a.setAttribute('href', data.filePath)
      a.setAttribute('download', "")
      a.click()
      console.log(data)
    },
  }
}
</script>

<style lang='scss'>

</style>